import { render, staticRenderFns } from "./EvaluatePeriodicUpdateDialog.vue?vue&type=template&id=a596d0b4&scoped=true"
import script from "./EvaluatePeriodicUpdateDialog.vue?vue&type=script&lang=js"
export * from "./EvaluatePeriodicUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluatePeriodicUpdateDialog.vue?vue&type=style&index=0&id=a596d0b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a596d0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a596d0b4')) {
      api.createRecord('a596d0b4', component.options)
    } else {
      api.reload('a596d0b4', component.options)
    }
    module.hot.accept("./EvaluatePeriodicUpdateDialog.vue?vue&type=template&id=a596d0b4&scoped=true", function () {
      api.rerender('a596d0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/EvaluatePeriodicUpdateDialog.vue"
export default component.exports